import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSignAndExecuteTransaction } from '../hooks/walletCompat';
import { Voting, NotificationComp } from 'ui-kit';
import { useSubscription } from '../hooks/useSubscription';
import { useNetworkString } from '../context/NetworkContext';
import { getIcon } from '../utils/getIcon';
import { buildVoteCards } from '../data/voteProposalsContent';
import { voteTransactionHandler } from '../utils/voteTransactionHandler';
const VotePage = ({ address, themeName = 'dark' }) => {
    var _a;
    const navigate = useNavigate();
    const { proposalId } = useParams();
    const network = useNetworkString();
    const signAndExecuteTransaction = useSignAndExecuteTransaction();
    const governanceRoom = address ? `governance:${address}` : null;
    const { data: governanceData } = useSubscription(governanceRoom);
    const [notificationInfo, setNotificationInfo] = useState({
        title: '',
        description: '',
    });
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [, setIsTransactionLoading] = useState(false);
    const [selectedVoteOption, setSelectedVoteOption] = useState(undefined);
    const [userVote, setUserVote] = useState(undefined);
    const [voteSuccess, setVoteSuccess] = useState(false);
    const [selectedVoteData, setSelectedVoteData] = useState(undefined);
    const voteCardsDataRef = useRef([]);
    const handleSubmitVote = (id, option) => {
        var _a, _b, _c;
        if (!address)
            return;
        const voteIndexMap = { For: 0, Against: 1, Abstain: 2 };
        const voteIndex = (_a = voteIndexMap[option]) !== null && _a !== void 0 ? _a : 0;
        const card = voteCardsDataRef.current.find((c) => c.proposalId === id);
        const proposalObjectId = (_c = (_b = card === null || card === void 0 ? void 0 : card.voteData) === null || _b === void 0 ? void 0 : _b.proposal) === null || _c === void 0 ? void 0 : _c.proposalObjectId;
        if (!proposalObjectId)
            return;
        setSelectedVoteOption(option);
        voteTransactionHandler({
            proposalObjectId: proposalObjectId,
            voteIndex: voteIndex,
            network: network === 'mainnet' ? 'mainnet' : undefined,
            address: address,
            signAndExecuteTransaction: signAndExecuteTransaction,
            setNotificationInfo: setNotificationInfo,
            setIsNotificationOpen: setIsNotificationOpen,
            setIsTransactionLoading: setIsTransactionLoading,
            voteOption: option,
            onVoteSuccess: () => {
                setUserVote(voteIndex);
                setVoteSuccess(true);
            },
        });
    };
    const createSubmitVoteHandler = (id) => (option) => handleSubmitVote(id, option);
    // Build cards when websocket data is available
    const voteCardsData = ((_a = governanceData === null || governanceData === void 0 ? void 0 : governanceData.proposals) === null || _a === void 0 ? void 0 : _a.length)
        ? buildVoteCards(governanceData.proposals, {
            getIcon: getIcon,
            createSubmitVoteHandler,
            themeName,
        })
        : [];
    voteCardsDataRef.current = voteCardsData;
    const handleCardClick = (card) => {
        if (card.voteData) {
            setSelectedVoteData(card.voteData);
            navigate(`/vote/${card.proposalId}`);
        }
    };
    const handleBack = () => {
        setSelectedVoteData(undefined);
        navigate('/vote');
    };
    const handleOptionChange = (e) => {
        setSelectedVoteOption(e.target.value);
    };
    // Sync selected proposal with URL and theme changes
    useEffect(() => {
        if (proposalId) {
            const card = voteCardsDataRef.current.find((p) => p.proposalId === proposalId);
            if (card === null || card === void 0 ? void 0 : card.voteData)
                setSelectedVoteData(card.voteData);
        }
        else {
            setSelectedVoteData(undefined);
        }
    }, [proposalId, governanceData, themeName]);
    const initialView = proposalId ? 'details' : 'list';
    return (_jsxs("div", { children: [!address ? (_jsx("div", { className: "theme-bg-alphafi-main-body w-full min-h-screen px-4 pt-6 flex items-center justify-center", children: _jsx("p", { className: "text-center theme-text-alphafi-secondary max-w-[400px]", children: "Connect your wallet to view and participate in governance proposals." }) })) : (_jsx(Voting, { voteCardsData: voteCardsData, initialView: initialView, onCardClick: handleCardClick, onOptionChange: handleOptionChange, createSubmitVoteHandler: createSubmitVoteHandler, selectedVoteOption: selectedVoteOption, userVote: userVote, voteSuccess: voteSuccess, selectedVoteData: selectedVoteData, onBack: handleBack, isSubmitDisabled: !address })), _jsx(NotificationComp, { isOpen: isNotificationOpen, setIsOpen: setIsNotificationOpen, info: notificationInfo })] }));
};
export default VotePage;
